










import Vue from "vue";

export default Vue.extend({
  name: "VForm",

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },

  methods: {
    async validate(): Promise<boolean> {
      const childrenWithValidation = this.$children.filter(
        children => "validate" in children
      );
      const promises = childrenWithValidation.map(children =>
        (children as any).validate()
      );

      const results = await Promise.all(promises);

      for (let i = 0; i < results.length; i += 1) {
        if (!results[i]) {
          return false;
        }
      }

      return true;
    },

    async submit(e: Event): Promise<void> {
      if ((await this.validate()) && !this.loading) {
        this.$emit("submit", e);
      }
    }
  }
});
